<ng-container *transloco="let t">
    <ng-container *ngIf="shop$ | async as shop">
        <ng-container
            *ngIf="
                shop.options.turn_on_the_store_link_feature === false &&
                    (!shop.options.turn_on_the_store_link_time ||
                        (shop.options.turn_on_the_store_link_time | dfnsParseIso | dfnsIsFuture));
                else shopDetail
            "
        >
            <div class="flex flex-col items-center justify-center h-full">
                <tui-svg src="svg::clock" size="l"></tui-svg>
                <h2
                    *ngIf="!shop.options.turn_on_the_store_link_time; else temporarilySuspendingOrdersTo"
                    class="text-xl tracking-tight text-gray-900 mt-4"
                >
                    {{ t('the_store_temporarily_stopped_accepting_orders') }}
                </h2>
                <ng-template #temporarilySuspendingOrdersTo>
                    <h2
                        class="text-xl tracking-tight text-gray-900 mt-2"
                        *tuiLet="shop.options.turn_on_the_store_link_time! | dfnsParseIso as suspendingOrdersTo"
                    >
                        {{
                            t('the_store_temporarily_stopped_ordering_up_to') +
                                ' - ' +
                                (suspendingOrdersTo
                                    | dfnsFormat : ((suspendingOrdersTo | dfnsIsToday) ? 'HH:mm' : 'HH:mm dd/MM/yyyy'))
                        }}
                    </h2>
                </ng-template>
            </div>
        </ng-container>

        <ng-template #shopDetail>
            <section class="pb-6">
                <div class="flex flex-col lg:flex-row gap-2">
                    <div class="lg:flex-none lg:w-1/2 lg:max-w-3xl" *ngIf="shop.banners?.length">
                        <us-banners-v2
                            [banners]="shop.banners"
                            [width]="416"
                            [height]="172"
                            aspectRatio="aspect-[3/1]"
                        ></us-banners-v2>
                    </div>
                    <div class="lg:flex-auto">
                        <us-breadcrumbs
                            [items]="[
                                {
                                    title: t('store_list'),
                                    routerLink: '/'
                                },
                                {
                                    title: t('home'),
                                    routerLink: undefined
                                }
                            ]"
                        ></us-breadcrumbs>
                        <h2 class="text-xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                            {{ shop.name }}
                        </h2>

                        <ul class="shop-detail mt-4">
                            <li *ngIf="shop.location && shop.location.latitude && shop.location.longitude">
                                <span class="flex items-baseline gap-1">
                                    <tui-svg src="svg::map-pin" size="s"></tui-svg>
                                    {{ shop.address }}
                                </span>
                                <span class="badge badge-indigo">
                                    {{ shop.location.distance | convertMeters }}
                                </span>
                            </li>

                            <li>
                                <tui-svg src="svg::clock" size="s"></tui-svg>
                                <span *tuiLet="shop | openTimeToDay | async as openTime">
                                    {{ openTime === null ? t('closed') : openTime }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <!-- <hr class="border-t border-gray-200 h-[1px] w-full mb-4" /> -->

            <section>
                <us-categories></us-categories>
            </section>
        </ng-template>
    </ng-container>
</ng-container>
